import React from "react";
import { ConfirmationRequest } from "../../../../../types/lobby";
import "./CrBox.scss";

interface Props {
  cr: ConfirmationRequest;
  isCompleted?: boolean;
}

const CrBox: React.FC<Props> = ({ cr, isCompleted = false }) => {
  const timeStr = new Date(cr.occurrence_datetime).toLocaleTimeString("ja-JP", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div
      className={`crCard ${cr.item_color} ${
        isCompleted ? "crCard-completed" : ""
      }`}
    >
      <div className="crLine">
        <div className="crTime">{timeStr}</div>
        <div className="crLabel">{cr.vehicle_label}</div>
        <div className="crClass">{cr.confirmation_request_class_name}</div>
      </div>
    </div>
  );
};

export default CrBox;
